import { render, staticRenderFns } from "./reporte-poker.vue?vue&type=template&id=05b01a5e&scoped=true"
import script from "./reporte-poker.vue?vue&type=script&lang=js"
export * from "./reporte-poker.vue?vue&type=script&lang=js"
import style0 from "./reporte-poker.vue?vue&type=style&index=0&id=05b01a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b01a5e",
  null
  
)

export default component.exports